<div class="story-slider-row text">
  <div class="story-slider-box">
    <div class="story-slider-item" [routerLink]="['/fav']" *ngIf="this._UiHelper.favPreMatches.length > 0">
      <div class="story-slider-icon-count">
        <image-loader-utils url="star" extraClasses="story-slider-icon favorited"></image-loader-utils>
        <div class="story-slider-count">
          {{ this._UiHelper.favPreMatches.length }}
        </div>
      </div>
      <div class="story-slider-sport-name">{{ 'Favourites' | t }}</div>
    </div>
    <div
      class="story-slider-item"
      *ngFor="let item of this._DataHelper.mainData; let i = index"
      [ngClass]="{ selected: item.SportId == this._DataHelper.selectedStorySportId }"
      (click)="getCountriesBySportsIDB3000(item, i)">
      <div class="story-slider-icon-count">
        <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="slidermenusvg"></image-loader-utils>
      </div>
      <div class="story-slider-sport-name">{{ item.SportName }}</div>
    </div>
  </div>
</div>

<div class="all-sports-time-filter-container">
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 24 }" (click)="changeTimeFilter(24)">{{ 'b3000_timeFilter_24' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 3 }" (click)="changeTimeFilter(3)">{{ 'b3000_timeFilter_3' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 6 }" (click)="changeTimeFilter(6)">{{ 'b3000_timeFilter_6' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 12 }" (click)="changeTimeFilter(12)">{{ 'b3000_timeFilter_12' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 72 }" (click)="changeTimeFilter(72)">{{ 'b3000_timeFilter_3_days' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 168 }" (click)="changeTimeFilter(168)">{{ 'b3000_timeFilter_week' | t }}</div>
  <div class="time-filter-item" [ngClass]="{ active: this._dayFilter == 300 }" (click)="changeTimeFilter(300)">{{ 'all' | t }}</div>
</div>
<fav-tournaments></fav-tournaments>

<div class="sports-menu-box">
  <ng-container *ngFor="let item of this._DataHelper.mainData; let i = index">
    <div class="sports-menu-item all-sports text" *ngIf="item.state">
      <div class="item-box">
        <ng-container *ngFor="let item2 of this._DataHelper.mainData[i].level; let k = index">
          <div class="sports-menu-dropdown h-40" [ngClass]="{ withLeague: item2.SportId == -99 }">
            <ng-template #allContainer>
              <div class="sports-menu-item row country" (click)="onClickAllEvent()">
                <div class="left">
                  <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="all-icon-svg"></image-loader-utils>
                </div>

                <div class="mid">{{ item2.CategoryName }}</div>
                <div class="right bg-light-gray">
                  <!-- {{this._DataHelper.totalCountAllEvent}} -->
                  {{ item2.CategoryEventCount }}
                </div>
              </div>
            </ng-template>

            <div
              id="sport-menu-item-{{ k }}"
              class="sports-menu-item row"
              (click)="getTourementsByCountryID(item.SportId, item2.CategoryId, i, k, 'sport-menu-item-')"
              *ngIf="item2.SportId != -100; else allContainer">
              <div class="left">
                <image-loader-utils [url]="item2.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
              </div>
              <div class="mid">{{ item2.CategoryName }}</div>
              <div class="right bg-light-gray">{{ item2.CategoryEventCount }}</div>
            </div>
          </div>
          <div class="item-box2" *ngIf="item2.state">
            <ng-container *ngFor="let item3 of this._DataHelper.mainData[i].level[k].level; let l = index">
              <div class="menu-content-item h-40">
                <div class="star-icon ml-5" (click)="add2TournamentFavs(item3, item2)">
                  <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                </div>
                <div class="mid" (click)="openLeague(item, item3, item2)">
                  {{ item3.TournamentName }}
                </div>
                <div class="right bg-light-gray">
                  <div class="event-count">
                    {{ item3.TournamentSportEventCount }}
                  </div>
                  <!-- <div class="star-icon"
                         [ngClass]="{'favorited' : item3.checked }"
                         (click)="add2TournamentFavs(item3,item2)">
                      <fa-icon [icon]="faIcons.faStar "></fa-icon>
                    </div> -->
                </div>
              </div>
            </ng-container>
            <ng-container *ngFor="let item3 of this._DataHelper.mainData[i].level[k].outrights; let l = index">
              <div class="menu-content-item">
                <div class="mid" [routerLink]="['/outright/' + item3.TournamentId]">{{ item3.TournamentName }} {{ 'SeasonBets' | t }}</div>
                <div class="right bg-light-gray">
                  <div class="event-count">
                    {{ item3.TournamentSportEventCount }}
                  </div>
                  <div class="star-icon d-none" [ngClass]="{ favorited: item3.checked }" (click)="add2TournamentFavs(item3, item2)">
                    <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
